import * as React from "react";
import { IMetricOptions, IMetricData } from "@curefit/metrics-common";
import { UserGoalView, Goal, TrackableSymptomViewModel, UserTrackableSymptomUpsertRequest } from "@curefit/gmf-common";
import ErrorContainer from "./../../containers/ErrorContainer"
import HealthTargetsEditViewCont from "../../containers/EditView/HealthTargetsEditViewCont";
import { EditViewDisplayMode } from "../common/EditViewCard";
import * as _ from "lodash";
import { AppMessages } from "../../utils/AppConstants";
import IMetric from "../../models/metrics/IMetric";
import IPatientLifestylePlanWrapper from "../../models/patients/IPatientLifestylePlanWrapper";
import AppUtils from "../../utils/AppUtils";
import OtherHealthTargetsEditViewCont from "../../containers/EditView/OtherHealthTargetsEditViewCont";
import TrackableSymptomsEditViewCont from "../../containers/EditView/TrackableSymptomsEditViewCont";
import ModelFactory from "../../models/ModelFactory";
/**
 * Created by abhinav on 05/02/18.
 */

export interface PatientGoalsTabProps {
    patientId: number,
    secondaryUserId: string,
    doctorId: number,
    consultationId: number,
    patientGoals: UserGoalView[],
    fetchPlanStaticData: () => void,
    staticGoals: Goal[],
    staticMetrics: IMetric[],
    saveEditedPatientGoals: (patientGoals: UserGoalView[]) => void,
    saveEditedPatientSecondaryGoals: (patientGoals: UserGoalView[]) => void,
    savePatientGoals: (patientId: number, patientGoals: UserGoalView[]) => Promise<any>,
    savePatientGoalsEdit: (patientId: number, req: any) => Promise<any>;
    nextTab: () => void,
    patientPlan: IPatientLifestylePlanWrapper,
    trackableSymptoms: TrackableSymptomViewModel[],
    patientTrackableSymptoms: UserTrackableSymptomUpsertRequest[],
    saveEditedPatientTrackableSymptoms: (trackableSymptoms: UserTrackableSymptomUpsertRequest[]) => void;
    isSelf: boolean;
    doctorType: string;
    savePatientTrackableSymptoms: (userId: number, reqData: UserTrackableSymptomUpsertRequest[]) => Promise<any>;
    deletePatientTrackableSymptoms: (userId: number, reqData: UserTrackableSymptomUpsertRequest[]) => Promise<any>;
    addUserMetric: (metricId: string, metricValue: number) => Promise<any>;
    getUserMetrics: (req: IMetricOptions) => void;
    patientMetrics: { [metricId: number]: IMetricData[] }
}

export interface PatientGoalsTabState {
    error: string,
    errorDetails?: string,
    isSaving?: boolean,
    modalScreen: number,
    isPatientGoalsSaved: boolean,
    assessmentMetricId: string
}

class PatientGoalsTab extends React.Component<PatientGoalsTabProps, PatientGoalsTabState> {
    private savedPrimaryHealthTargetsEditViewRef: any[];
    private savedOtherHealthTargetsEditViewRef: any[];
    private healthTargetsEditViewRef: any;
    private otherHealthTargetsEditViewRef: any;
    private trackableSymptomsRef: TrackableSymptomsEditViewCont;

    constructor(props: PatientGoalsTabProps) {
        super(props);
        this.savedOtherHealthTargetsEditViewRef = [];
        this.savedPrimaryHealthTargetsEditViewRef = [];
        this.state = {
            error: null,
            isSaving: false,
            modalScreen: null,
            isPatientGoalsSaved: false,
            assessmentMetricId: null
        }
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }

    componentDidMount() {
        document.addEventListener("visibilitychange", this.handleVisibilityChange)
    }

    handleVisibilityChange() {
        if (!document.hidden) {
            if (AppUtils.isDefined(this.state.assessmentMetricId)) {
                let userMetricReq = ModelFactory.createUserMetricReqObject(this.props.patientId.toString(), this.props.secondaryUserId, Number(this.state.assessmentMetricId), this.props.isSelf);
                userMetricReq.sortDesc = true;
                this.props.getUserMetrics(userMetricReq);
            }
        }
    }

    generateScrollItems = () => {
        return [
            { name: "Health Targets", component: "health-target-section" },
            { name: "Build Plan", component: "build-plan-section" },
        ]
    }
    componentWillUnmount() {
        this.saveEditedGoals()
        document.removeEventListener("visibilitychange", this.handleVisibilityChange)
    }
    getSavedGoals = () => {
        let goals: UserGoalView[] = [];
        _.map(this.savedPrimaryHealthTargetsEditViewRef, (savedPrimaryGoalsRef) => {
            if (!_.isEmpty(savedPrimaryGoalsRef)) {
                goals = goals.concat(savedPrimaryGoalsRef.getSaveObject());
            }
        })
        if (!_.isEmpty(this.otherHealthTargetsEditViewRef)) {
            let otherGoals = this.otherHealthTargetsEditViewRef.getSaveObject();
            let savedOtherGoals = otherGoals.filter((item: any) => item._id !== null && item._id !== undefined);
            if (savedOtherGoals.length)
                goals = goals.concat(savedOtherGoals);
        }
        return goals;
    }
    saveEditedGoals = () => {
        let unsavedPrimaryGoals = !this.state.isPatientGoalsSaved ? [...this.healthTargetsEditViewRef.getSaveObject()] : [];
        let unsavedOtherGoals = [...this.otherHealthTargetsEditViewRef.getSaveObject()].filter(item => !AppUtils.isDefined(item._id));
        let savedGoals = this.getSavedGoals();
        let savedTrackableSymptom = this.trackableSymptomsRef.getSaveObject();
        this.props.saveEditedPatientGoals(unsavedPrimaryGoals.concat(unsavedOtherGoals).concat(savedGoals));
        this.props.saveEditedPatientTrackableSymptoms(savedTrackableSymptom);
    }
    savePatientGoals = () => {
        this.saveEditedGoals();
        let isGoalsFormDirty = this.healthTargetsEditViewRef.isFormDirty();
        let isTrackableSymptomsFormDirty = this.trackableSymptomsRef.isFormDirty();
        let symptoms = this.trackableSymptomsRef.getSaveObject();
        this.setState({ isSaving: true });
        if (!isGoalsFormDirty && !isTrackableSymptomsFormDirty && !this.state.isPatientGoalsSaved) {
            let goals = [...this.healthTargetsEditViewRef.getSaveObject()];
            let otherGoals = [...this.otherHealthTargetsEditViewRef.getSaveObject().filter((item: any) => _.isEmpty(item._id))];
            let finalGoals = goals.concat(otherGoals);
            let goalsSaveObject = AppUtils.generateGoalsSaveObject(finalGoals, this.props.consultationId, this.props.doctorId);
            let myInstance = this;
            if (finalGoals.length > 0) {
                this.props.savePatientGoals(this.props.patientId, goalsSaveObject).then((savedGoals) => {
                    this.props.launchPatientGoals(this.props.patientId.toString(), this.props.consultationId, this.props.doctorId).then(() => {
                        myInstance.setState({ isPatientGoalsSaved: true }, () => {
                            this.props.saveEditedPatientGoals(this.getSavedGoals().concat(savedGoals));
                            this._savePatientSymptoms(symptoms);
                        });
                    })
                }).catch((err: any) => {
                    this.setState({
                        error: AppMessages.GOALS_SAVE_ERROR,
                        errorDetails: err.message,
                        isSaving: false,
                        isPatientGoalsSaved: false
                    })
                });
            } else {
                this.props.launchPatientGoals(this.props.patientId.toString(), this.props.consultationId, this.props.doctorId).then(() => {
                    this._savePatientSymptoms(symptoms);
                })
            }
        } else if (!isGoalsFormDirty && !isTrackableSymptomsFormDirty && this.state.isPatientGoalsSaved) {
            this._savePatientSymptoms(symptoms);
        } else {
            this.setState({
                error: AppMessages.GOALS_VALIDATION_ERROR,
                errorDetails: this.healthTargetsEditViewRef.dirtyFormText(),
                isSaving: false
            })
        }
    }

    _savePatientSymptoms = (requestSymptoms: UserTrackableSymptomUpsertRequest[]) => {
        const updatedSymptoms = requestSymptoms.filter(symptom => !AppUtils.isDefined(symptom.userTrackableSymptomObj._id));
        this.props.savePatientTrackableSymptoms(this.props.patientId, updatedSymptoms).then((savedSymptoms) => {
            let savedSymptomsArray: UserTrackableSymptomUpsertRequest[] = [];
            if (!_.isEmpty(savedSymptoms)) {
                savedSymptoms.map((symptom => {
                    if (!_.isEmpty(symptom) && !_.isEmpty(symptom.trackableSymptom) && AppUtils.isDefined(symptom.upsertStatus)) {
                        delete symptom.upsertStatus;
                        savedSymptomsArray.push({
                            userTrackableSymptomId: symptom.trackableSymptom._id,
                            userTrackableSymptomObj: symptom.trackableSymptom
                        })
                    }
                }))
            }
            let symptomsToBeSaved = requestSymptoms.filter(symptom => AppUtils.isDefined(symptom.userTrackableSymptomObj._id)).concat(savedSymptomsArray);
            this.props.saveEditedPatientTrackableSymptoms(symptomsToBeSaved);
            this.props.nextTab();
        }).catch((err: any) => {
            this.setState({
                error: AppMessages.GOALS_SAVE_ERROR,
                errorDetails: err.message,
                isSaving: false
            })
        });
    };

    clearErrorMessage = () => {
        this.setState({
            error: null,
            errorDetails: null
        })
    }

    _setAssessmentMetric = (metricId: string) => {
        this.setState({ assessmentMetricId: metricId })
    }

    render() {
        let goals = !_.isEmpty(this.props.patientGoals) ? this.props.patientGoals.filter(item => item.userGoalType === "PRIMARY") : [];
        let secondaryGoals = !_.isEmpty(this.props.patientGoals) ? this.props.patientGoals.filter(item => item.userGoalType === "OTHER") : [];
        let errorMessage = !_.isNull(this.state.error) ? this.state.error : AppMessages.VITALS_AND_ALLERGIES_SAVE_ERROR;
        let errorDetails = !_.isNull(this.state.errorDetails) ? this.state.errorDetails : "";
        let saveButtonValue = this.state.isSaving ? "Saving..." : "Save";
        let modalScreen = this.state.modalScreen;
        let symptoms: UserTrackableSymptomUpsertRequest[] = [];
        return (
            <div className="patient-clinical-plan-container">
                {/*<ScrollToContainer componentToScroll={document.getElementsByClassName("ongoing-consultation-main-cont")[0]} scrollItems={this.generateScrollItems()}/>*/}
                {
                    !_.isNull(this.state.error) &&
                    <ErrorContainer errorText={errorMessage} errorDetails={errorDetails} errorCode={0} closeError={this.clearErrorMessage} />
                }
                {
                    _.map(goals, (goal, index) => {
                        if (goal._id !== undefined) {
                            return <div className="patient-info-subsection health-target-section" key={goal._id}>
                                <HealthTargetsEditViewCont ref={(goalsDOM) => this.savedPrimaryHealthTargetsEditViewRef[index] = goalsDOM} secondaryUserId={this.props.secondaryUserId}
                                    goalsType={"PRIMARY"} doctorId={this.props.doctorId} appointmentId={this.props.consultationId}
                                    staticGoals={this.props.staticGoals} staticMetrics={this.props.staticMetrics} isSelf={this.props.isSelf}
                                    fetchPlanStaticData={this.props.fetchPlanStaticData} savePatientGoalsEdit={this.props.savePatientGoalsEdit}
                                    patientId={this.props.patientId} patientGoals={[goal]} preventGoalAddition={true}
                                    addUserMetric={this.props.addUserMetric} getUserMetrics={this.props.getUserMetrics} patientMetrics={this.props.patientMetrics} setAssessmentMetric={this._setAssessmentMetric} />
                            </div>
                        }
                    })
                }
                <div className="patient-info-subsection health-target-section">
                    <HealthTargetsEditViewCont ref={(goalsDOM) => { this.healthTargetsEditViewRef = goalsDOM }} secondaryUserId={this.props.secondaryUserId}
                        goalsType={"PRIMARY"} doctorId={this.props.doctorId} appointmentId={this.props.consultationId}
                        staticGoals={this.props.staticGoals} staticMetrics={this.props.staticMetrics} isSelf={this.props.isSelf}
                        displayMode={EditViewDisplayMode.EDIT} fetchPlanStaticData={this.props.fetchPlanStaticData}
                        patientId={this.props.patientId} patientGoals={goals.filter(item => _.isEmpty(item._id))}
                        addUserMetric={this.props.addUserMetric} showActionIcons={true}
                        getUserMetrics={this.props.getUserMetrics} patientMetrics={this.props.patientMetrics} setAssessmentMetric={this._setAssessmentMetric} />
                </div>
                <div className="patient-info-subsection health-target-section">
                    <OtherHealthTargetsEditViewCont isSelf={this.props.isSelf} ref={(goalsDOM) => { this.otherHealthTargetsEditViewRef = goalsDOM }}
                        savePatientGoalsEdit={this.props.savePatientGoalsEdit} secondaryUserId={this.props.secondaryUserId}
                        titleToDisplay={"Other Goals"} goalsType={"OTHER"} doctorId={this.props.doctorId}
                        staticGoals={this.props.staticGoals} staticMetrics={this.props.staticMetrics}
                        displayMode={EditViewDisplayMode.EDIT} fetchPlanStaticData={this.props.fetchPlanStaticData}
                        patientId={this.props.patientId} patientGoals={secondaryGoals} />
                </div>
                <div className={"patient-info-subsection"}>
                    <TrackableSymptomsEditViewCont patientId={this.props.patientId}
                        staticTrackableSymptoms={this.props.trackableSymptoms} trackableSymptoms={symptoms}
                        patientTrackableSymptoms={this.props.patientTrackableSymptoms} displayMode={EditViewDisplayMode.EDIT}
                        ref={(trackableSymptomsRef) => this.trackableSymptomsRef = trackableSymptomsRef}
                        secondaryUserId={this.props.secondaryUserId} isSelf={this.props.isSelf}
                        appointmentId={this.props.consultationId} doctorId={this.props.doctorId}
                        doctorType={this.props.doctorType}
                        deletePatientTrackableSymptoms={this.props.deletePatientTrackableSymptoms} />
                </div>
                <div className={"save-button collapsible-card"}>
                    <input disabled={this.state.isSaving} className="card-primary-action" type="button" value={saveButtonValue} onClick={() => { this.savePatientGoals() }} /></div>
            </div>
        );
    }
}

export default PatientGoalsTab